import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { DM_Sans } from 'next/font/google'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/ui/views'

const sans = DM_Sans({
    subsets: ['latin'],
    axes: ['opsz']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='robots' content='noindex' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Head>

            <Component {...pageProps} />
        </Layout>
    )
}

export default App
